import { defineMessages } from 'react-intl';

export default defineMessages({
  COURSES_LABEL: {
    defaultMessage: 'Formations',
  },

  STATUS_LABEL: {
    defaultMessage: 'Statut',
  },

  STREAKS_LABEL: {
    defaultMessage: 'Record de connexions',
  },

  STUDENT_ID_LABEL: {
    defaultMessage: 'Numéro étudiant',
  },

  COURSE_LIMITED_TAG: {
    defaultMessage: 'Terminé',
  },

  LANGUAGE_LABEL: {
    defaultMessage: 'Langue',
  },
  THEME_MODE_LABEL: {
    defaultMessage: 'Thème',
  },
} as const);
